<template>
  <div id="app">
    <mpNav></mpNav>
    <mpLoginReg></mpLoginReg>
    <div id="v-content" v-bind:style="{ minHeight: Height + 'px' }">
      <router-view />
    </div>
    <mpFooter></mpFooter>

    <Modal
      v-model="dialogVisible"
      width="620"
      :closable="false"
      :mask-closable="false"
      class-name="vitcalDev"
    >
      <p slot="header" style="color:#303133;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>公告</span>
      </p>
      <div style="">
        <p>
          即日起，MPai客户端（单机）进行封版，不再发布新版本！mpai不再支持购买会员及下载，老用户已下载的可正常使用mpai。
        </p>
        <p>
          新版本SPSSPRO已经上线（完全免费），全新的操作流程与体验，目前已经覆盖mpai所有功能、并会在2022年6月前上线自动绘图、导出代码等等，请各位移步至SPSSPRO。
        </p>
      </div>
      <div slot="footer" style="text-align:center">
        <Button type="primary" @click="gotoSpsspro">前往SPSSPRO</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import mpNav from "@/components/mp-header/mp-nav.vue";
import mpFooter from "@/components/mp-footer/mp-footer.vue";
import mpLoginReg from "@/components/mp-login/mp-login-reg.vue";
export default {
  components: {
    mpNav,
    mpFooter,
    mpLoginReg
  },
  data() {
    return {
      fullWidth: 0,
      dialogVisible: true
    };
  },
  computed: {
    Height: {
      get() {
        return this.$store.state.height;
      },
      set(height) {
        this.$store.dispatch("commitHeight", height);
      }
    }
  },
  methods: {
    gotoSpsspro() {
      window.location.href = "https://www.spsspro.com/?utm_source=mpai";
    }
  },
  watch: {
    fullWidth() {
      //监控浏览器宽度变化
      if (!this.timer) {
        //改变宽度变化
        this.setRem.setRem();
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 200);
      }
    }
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 364; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 364;
    };
    this.fullWidth = `${document.documentElement.clientWidth}`;
    window.onresize = () => {
      this.fullWidth = document.documentElement.clientWidth - 364;
    };
  }
};
</script>
<style lang="less" scope>
#app {
  font-family: "微软雅黑";
  // width: 100vw;
}
[class^="icon-mpai"],
[class*="icon-mpai"] {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-mpai-colors {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.vitcalDev {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>
